import { useMutation } from '@apollo/client/react';
import { useSetAtom } from 'jotai';
import { useResetAtom } from 'jotai/utils';
import { useCallback, useState } from 'react';

import { Fields } from '~/components/partials/GuestPatientForm/types';
import { CreateDirectVisitorDocument } from '~/graphql/generated/graphql';
import { patientDetailDialogState } from '~/state/partials/patient_detail_dialog/atoms';
import { TabType } from '~/state/partials/patient_detail_dialog/types';
import { newPatientDrawerState } from '~/state/patient/atoms';

export const useCreateDirectVisitor = () => {
  const [isCreating, setIsCreating] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const resetState = useResetAtom(newPatientDrawerState);
  const setPatientDetailDialogState = useSetAtom(patientDetailDialogState);

  const [createDirectVisitor] = useMutation(CreateDirectVisitorDocument);

  const create = useCallback(
    async (values: Fields) => {
      setIsCreating(true);
      setError(null);

      const sex = values.sex === 'male' ? 'male' : values.sex === 'female' ? 'female' : 'unknown';

      try {
        const result = await createDirectVisitor({
          variables: {
            input: {
              ...values,
              sex,
            },
          },
        });

        const directVisitorId = result.data?.createDirectVisitor?.directVisitor.id;
        if (directVisitorId) {
          setPatientDetailDialogState((_state) => ({
            ..._state,
            isOpen: true,
            type: 'message' as TabType,
            patientId: directVisitorId,
          }));
        }
        resetState();
      } catch (_error) {
        const _message = _error?.message || 'エラーが発生しました';
        setError(_message);
        throw new Error(_message, { cause: _error });
      } finally {
        setIsCreating(false);
      }
    },
    [createDirectVisitor, setPatientDetailDialogState, resetState],
  );

  return {
    creating: isCreating,
    error,
    create,
  };
};
